import { render, staticRenderFns } from "./mobileVideoBxt.vue?vue&type=template&id=1d718716&scoped=true&"
import script from "./mobileVideoBxt.vue?vue&type=script&lang=js&"
export * from "./mobileVideoBxt.vue?vue&type=script&lang=js&"
import style0 from "./mobileVideoBxt.vue?vue&type=style&index=0&id=1d718716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d718716",
  null
  
)

export default component.exports